import { useParams } from "react-router-dom";
import "./DestinationDetails.scss";
import { destinations } from "../components/destinations/destinations.data";
import NearbyDestinations from "../components/destinations/NearbyDestinations";
export default function DestinationDetails() {
  const { slug } = useParams();

  const destination = destinations.find((d) => d.slug === slug);

  if (!destination) {
    return (
      <div className="destination-not-found">
        <h2>Destination not found</h2>
      </div>
    );
  }

  return (
    <div className="destination-details">
      {/* Hero */}
      <section
        className="destination-hero"
        style={{ backgroundImage: `url(${destination.heroImage})` }}
      >
        <div className="destination-hero__overlay">
          <div className="container destination-hero__content">
            <h1>{destination.title}</h1>
            <p>{destination.region}</p>
          </div>
        </div>
      </section>

      {/* Overview */}
      <section className="destination-overview container">
        <div className="destination-overview__content">
          <h2>Overview</h2>
          <p>{destination.description}</p>

          <h3>Highlights</h3>
          <ul className="highlights">
            {destination?.highlights?.map((h, i) => (
              <li key={i}>{h}</li>
            ))}
          </ul>
        </div>

        {/* Map */}
        <div className="destination-map">
          <iframe
            src={destination.mapEmbed}
            loading="lazy"
            title={`${destination.title} map`}
          />
        </div>
      </section>

      {/* Related Content */}
      <section className="destination-related">
        <div className="container destination-related__grid">
          <div>
            <h3>Guides</h3>
            <ul>
              {destination?.guides?.map((g, i) => (
                <li key={i}>
                  <a href={g.link}>{g.title}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3>Watch</h3>
            <ul>
              {destination?.videos?.map((v, i) => (
                <li key={i}>
                  <a href={v.link}>{v.title}</a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
      <NearbyDestinations
        currentSlug={destination.slug}
        region={destination.region}
        destinations={destinations}
      />
    </div>
  );
}
